import { Link } from "react-router-dom";
import { slugifyCountry, useCountries } from "../context/CountryContext";

export default function ExploreByCountry() {
  const { countries, loading } = useCountries();
  if (loading || !countries.length) return null;
  return (
    <section className="py-24 bg-[#f2f4f6]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-[#00255a] mb-4">
            Explore Our Study Destinations
          </h2>
          <p className="text-[#64748b] max-w-2xl mx-auto">
            Discover study and work opportunities in our active destinations.
          </p>
        </div>
        <div className="flex md:grid md:grid-cols-4 gap-6 overflow-x-auto md:overflow-visible pb-8 md:pb-0 snap-x">
          {countries.map((country) => (
            <Link
              key={country.country}
              to={`/why-choose/${slugifyCountry(country.country)}`}
              className="min-w-[280px] md:min-w-0 snap-start group"
            >
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-105 transition-all">
                <div className="absolute inset-0 bg-[#00255a]">
                  {country.heroImageUrl && (
                    <img
                      alt={country.country}
                      className="w-full h-full object-cover"
                      src={country.heroImageUrl || `/images/countries/${country.country.toLowerCase().replace(/\s+/g, '-')}.jpg`} 
                    />
                  )}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#1e3c72]/80 via-[#1e3c72]/30 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-6 text-center">
                  <h3 className="text-white text-xl font-semibold">
                    {country.country}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
